export const BASE_URL =
  process.env.REACT_APP_API_URL || "https://demo.clever-botics.com/api/v1/";
export const BASE_ADMIN_URL =
  process.env.REACT_APP_ADMIN_API_URL ||
  "https://demo.clever-botics.com/admin-api/v1/";

export const API_PATHS = {
  //AUTH

  AUTH_LOGIN: "auth/login/",
  AUTH_REGISTER: "auth/register/",
  AUTH_LOGOUT: "auth/logout/",
  AUTH_VERIFICATION: "email/verify",
  AUTH_RESET_PASSWORD: "/auth/reset-password/",
  AUTH_RESET_VERIFY: "auth/reset-verify/",
  AUTH_GOOGLE_TOKEN: "auth/google/token/",

  ADMIN_AUTH: "/auth/login/",
  ADMIN_MAIN_STATS: "/dashboard/key_metrics",
  ADMIN_USERS_LIST: "users",
  ADMIN_ASSISTANTS_LIST: "assistants",
  ADMIN_SUBSCRIPTION_LIST: "subscription-plans",
  ADMIN_NOTIFICATIONS_LIST: "notifications",
  ADMIN_REWARDS: "referral-rewards",

  CHAT_SUPPORT: "faq-chat/",

  PROFILE_INFO: "profile/",
  PROFILE_LOCATION: "/profile/location/",

  REFERRALS: "referrals/",
  REFERRALS_STATS: "referrals/stats",

  SUBSCRIPTION_PLANS: "subscription-plans",

  MESSAGES_LIST: "conversations",
  MESSAGES_SEND: "/send_message",

  CONVERSATION_ANALYSIS: "conversation-analysis",

  TELEGRAM_LIST: "telegram-integrations",
  TWILIO_INTEGRATIONS: "twilio-integrations/",
  WHATSAPP_INTEGRATIONS: "whatsapp-integrations/",
  TELEGRAM_CREATE_CHANNEL: "/employees/create_with_telegram/",

  KNOWLEDGE_BASES: "knowledge-bases/",
  QA_PAIRS_EDIT: "qa-pairs/",
  EXCEL_UPLOAD: "qa-pairs/import_file/",

  USER_STATISTICS: "user-subscription/usage/",

  //WORKFLOWS

  WORKFLOWS: "workflows/",
  NODE: "workflow-nodes/",

  ACTION_TEMPLATES: "actions-templates/",

  BUSINESS_CARDS: "business-cards/",
  BUSINESS_CARD: "business-card/",
  BUSINESS_CARDS_STATS: "statistics/",

  // TICKETS

  TICKETS_LIST: "support-ticket",

  ADMIN_TICKET_LIST: "tickets",

  ADMIN_TEMPLATES: "templates",
  ADMIN_BUSINESS_CARDS: "business-cards/",

  EMPLOYEES_CREATE: "employees/",
  EMPLOYEES_CLONE: "/clone-bot/",
  EMPLOYEES_INTEGRATION_SWITCH: "-google-service/",
  EMPLOYEES_SHARE_LINKS: "employees/share-links/",

  NEWSLETTERS_LIST: "newsletter/",

  NOTIFICATIONS_LIST: "notifications",
  FAQ_LIST: "faq",

  TEAM: "teams/",
  TEAM_INVITE: "teams/invitations/",

  REWARDS: "rewards/",
  REWARDS_REDEEM: "rewards/redeem/",

  //INTEGRATIONS
  INTEGRATION_CREATE: "google/oauth/init/",
  INTEGRATION_DISCONNECT: "google/disconnect/",
  INTEGRATION_MANAGE: "google/integrations/",

  //CONTACT
  CONTACT_REQUESTS: "contact-requests",

  //TEMPLATES
  BOT_GALLERY: "bot-templates",
  CLIENT_BOT_LIST: "bot-templates/my_purchases",
  BOT_TEMPLATES_QUESTIONS: "bot-templates/",
  BOT_TEMPLATE_CREATE: "/create_assistant/",
  BOT_TEMPLATE_CATEGORIES: "/bot-categories",
  QUICK_BOT_GENERATE_PROMPT: "quick-bot/generate-prompt/",
  QUICK_BOT_CREATE: "quick-bot/",

  PROMOCODE_LIST: "user-promocodes",

  DOCUMENT_UPLOAD: "documents/",
  DOCUMENT_LIST: "knowledge-bases/",

  SUBSCRIPTION_INFO: "user-subscription/stats",
  SUBSCRIPTION_CANCEL: "user-subscription/cancel/",

  PACKAGE_TRIAL: "payments/activate_trial/",
  PACKAGE_TRANSACTION: "payments/create_payment/",

  PAYMENTS: "payments",
  PAYMENTS_ACTIVATE: "payments/activate_subscription/",
  PROMO_VALIDATION: "validate_promocode",

  //EXPORT FILES
  EXPORT_USERS_DATA: "users/export/",
  EXPORT_PAYMENTS_DATA: "payments/export/",
  EXPORT_ASSISTANTS_DATA: "assistants/export/",

  //FAQ
  ADMIN_FAQ_LIST: "faqs",

  WIDGETS: "widgets/",
  ADMIN_INTEGRATIONS: "integrations/",
  INTEGRATIONS_ALL: "integrations/all/",

  INSTAGRAM: "instagram/",
  INSTAGRAM_OAUTH_INIT: "instagram/oauth/init/",
  INSTAGRAM_CONNECT: "instagram/connect/",
};
